/* Zydonia Redesign im Craft-Theme: Startseiten-Abschnitte (Hero, Neuroparfum, Düfte, Sets, Philosophie, Ritual, Bewertungen, Geschenk).
   Klassen mit Craft-Kollision tragen das Präfix zy- (zy-media, zy-card, zy-badge, zy-link, zy-swatch). */
(function () {
  const D = window.ZY, site = window.ZYSite, cart = window.ZYCart;
  if (!D || !site || !document.querySelector('.zyx')) return;
  const roomUrl = (D.scents.find(s => !s.soldOut) || D.scents[0]).url.split('?')[0];
  const railEl = document.querySelector('[data-rail]');
  const finderUrl = (railEl && railEl.dataset.finder) || roomUrl;
  const { reduce, hasGSAP } = site;
  const gsap = window.gsap;
  // Fehlt ein Abschnitt (im Theme-Editor entfernt), wird in ein unsichtbares Ersatz-Element geschrieben statt abzubrechen
  const $ = (s, r) => (r || document).querySelector(s) || document.createElement('div');
  const has = s => !!document.querySelector(s);
  const $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

  /* ---------- Neuroparfum: Anziehung, Präsenz, Selbstbewusstsein ---------- */
  // Parfum-Paneele pflegt man als Blöcke im Theme-Editor; nur ohne Blöcke die drei Neuroparfums aus zy-data.js
  const pfPanels = $('[data-pf-panels]');
  if (!pfPanels.children.length) pfPanels.innerHTML = D.perfumes.map(p => `
    <a class="pfp" href="${p.url}" style="--c:${p.glow}">
      <img src="${D.img(p.lifes[0], 1200)}" srcset="${D.img(p.lifes[0], 700)} 700w, ${D.img(p.lifes[0], 1200)} 1200w" sizes="(max-width: 1023px) 78vw, 40vw" alt="${p.name}: ${p.effect}" loading="lazy">
      <span class="pfp__body">
        <span class="pfp__for">${p.for}</span>
        <span class="pfp__effect">${p.short}.</span>
        <span class="pfp__row"><span><b>${p.name}</b>, ab ${D.eur(D.ptier(5).price / 5)} pro Flakon</span><span class="pfp__go">Entdecken<i class="ph-light ph-arrow-right" aria-hidden="true"></i></span></span>
      </span>
    </a>`).join('');
  const pfVideo = document.querySelector('[data-pf-video]');
  if (pfVideo && !reduce) {
    const loadPf = () => {
      const src = D.asset('pf-trio.mp4', D.isLight());
      if (pfVideo.getAttribute('src') === src) return;
      pfVideo.classList.remove('is-ready');
      pfVideo.setAttribute('src', src);
      pfVideo.addEventListener('canplay', () => { const pr = pfVideo.play(); if (pr && pr.then) pr.then(() => pfVideo.classList.add('is-ready')).catch(() => {}); }, { once: true });
      pfVideo.load();
    };
    new IntersectionObserver((es, io) => { if (es[0].isIntersecting) { loadPf(); io.disconnect(); window.addEventListener('zy:theme', loadPf); } }, { rootMargin: '300px' }).observe(pfVideo);
  }

  /* ---------- Neun Düfte ---------- */
  $('[data-rail]').innerHTML = D.scents.map(s => `
    <article class="zy-card${s.soldOut ? ' card--soldout' : ''}" style="--c:${s.glow}">
      <a class="zy-card__media zy-media" href="${s.url}" aria-label="${s.name} ansehen">
        <img src="${D.img('pack-' + s.id, 600)}" srcset="${D.img('pack-' + s.id, 600)} 600w, ${D.img('pack-' + s.id, 1200)} 1200w" sizes="(max-width: 1023px) 76vw, 26vw" alt="Raumduft ${s.name}" loading="lazy">
        ${s.soldOut ? '<span class="zy-soldout">Ausverkauft</span>' : ''}
      </a>
      <div class="card__body">
        <div class="card__row"><a class="card__name" href="${s.url}">${s.name}</a></div>
        <span class="card__mood">${s.mood}</span>
        <span class="card__notes">${s.notes.join(', ')}</span>
        <div class="card__foot">
          ${s.soldOut
            ? `<span class="card__price muted">Gerade ausverkauft</span><a class="zy-link" href="${s.url}">Benachrichtigen</a>`
            : `<span class="card__price num">${D.eur(D.single)}</span><button class="card__add" type="button" data-quick="${s.id}" aria-label="${s.name} in den Warenkorb"><i class="ph-light ph-plus" aria-hidden="true"></i></button>`}
        </div>
      </div>
    </article>`).join('') + `
    <article class="zy-card card--end">
      <p class="display-s" style="margin:0">Nicht sicher, welcher Duft zu dir passt?</p>
      <div style="display:grid;gap:18px">
        <p class="muted" style="margin:0">Such dir deinen Moment aus, wir zeigen dir die passenden Düfte.</p>
        <a class="zy-link" href="${finderUrl}">Zum Duft-Finder</a>
      </div>
    </article>`;

  /* ---------- Sets ---------- */
  const chips = ids => ids.map(id => { const s = D.scent(id); return `<span class="chip"><i class="zy-swatch" style="--c:${s.label}"></i>${s.name}</span>`; }).join('');
  $('[data-sets]').innerHTML = D.sets.map(set => `
    <article class="set">
      <div class="set__media zy-media" data-reveal="clip"><img src="${D.img(set.img, 1200)}" alt="Set ${set.name}: ${set.scents.map(id => D.scent(id).name).join(', ')}" loading="lazy"></div>
      <div class="set__body">
        <h3 class="display-m">${set.name}</h3>
        <p class="muted" style="margin:0;max-width:44ch">${set.text}</p>
        <div class="set__scents">${chips(set.scents)}</div>
        <div class="set__price"><strong class="num">${D.eur(D.tier(3).price)}</strong><span class="muted small">einzeln ${D.eur(D.single * 3)}</span></div>
        <div class="set__actions">
          <button class="btn btn--light" type="button" data-add-set="${set.id}"${set.scents.some(id => D.scent(id).soldOut) ? ' disabled' : ''}>In den Warenkorb</button>
          <a class="btn btn--ghost" href="${roomUrl}">Düfte tauschen</a>
        </div>
      </div>
    </article>`).join('') + `
    <article class="set set--c">
      <div class="set__body">
        <h3 class="display-m">Dein eigenes Set</h3>
        <p class="muted" style="margin:0;max-width:40ch">Wähl aus neun Düften. Je mehr du kombinierst, desto weniger zahlst du pro Flakon.</p>
        <div class="ladder num">${D.tiers.map(t => `<span>${t.qty} ${t.qty === 1 ? 'Duft' : 'Düfte'} <b>${D.eur(t.price)}</b></span>`).join('')}</div>
        <div class="set__actions"><a class="btn btn--light" href="${roomUrl}">Set zusammenstellen</a></div>
      </div>
      <div class="set__media zy-media" data-reveal="clip"><img src="${D.asset('sets-boxes-1600.webp')}" srcset="${D.asset('sets-boxes-900.webp')} 900w, ${D.asset('sets-boxes-1600.webp')} 1600w" sizes="(max-width: 1023px) 100vw, 60vw" alt="Alle neun Zydonia-Raumdüfte in ihren Kartons auf einer Steinplatte, dazu Lavendel, Rosen, Ingwer und Zitrus" loading="lazy"></div>
    </article>`;

  /* ---------- Bewertungen: nur ohne Blöcke im Theme-Editor die Stimmen aus zy-data.js ---------- */
  const track = $('[data-marquee]');
  const reviewHTML = r => `
    <figure class="review" style="margin:0">
      <span class="stars" aria-hidden="true">${'<i class="ph-fill ph-star"></i>'.repeat(5)}</span>
      <blockquote>„${r.text}“</blockquote>
      <footer><strong>${r.name}</strong><span>${r.verified ? 'Verifizierter Kauf' : r.date}</span></footer>
    </figure>`;
  if (!track.querySelector('.review')) track.innerHTML = D.reviews.map(reviewHTML).join('') + D.reviews.map(reviewHTML).join('').replace(/<figure class="review"/g, '<figure aria-hidden="true" class="review"');

  /* ---------- Hero ---------- */
  const heroTitle = $('[data-hero-title]');
  const video = document.querySelector('[data-hero-video]');
  if (!reduce && video) {
    const portrait = window.matchMedia('(max-aspect-ratio: 4/5), (max-width: 599px)');
    const load = () => {
      const src = D.asset(portrait.matches ? 'hero-mobile.mp4' : 'hero-desktop.mp4', D.isLight());
      if (video.getAttribute('src') === src) return;
      video.classList.remove('is-ready');
      video.setAttribute('src', src);
      video.addEventListener('canplay', () => {
        const p = video.play();
        if (p && p.then) p.then(() => video.classList.add('is-ready')).catch(() => {});
        else video.classList.add('is-ready');
      }, { once: true });
      video.load();
    };
    load();
    portrait.addEventListener('change', load);
    window.addEventListener('zy:theme', load);
  }
  if (hasGSAP && !reduce && has('.hero')) {
    const words = site.split(heroTitle);
    gsap.set(heroTitle, { opacity: 1 });
    gsap.timeline({ delay: .1 })
      .to('.zyx .hero__fade', { opacity: 0, duration: 1.8, ease: 'power2.out' })
      .fromTo('.zyx .hero__zoom', { scale: 1.14 }, { scale: 1, duration: 3, ease: 'expo.out' }, 0)
      .fromTo(words, { yPercent: 115 }, { yPercent: 0, duration: 1.5, ease: 'expo.out', stagger: .07 }, .45)
      .fromTo('.zyx [data-hero-fade]', { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 1.2, ease: 'expo.out', stagger: .14 }, 1.0);
    gsap.to('.zyx .hero__media', { yPercent: 14, ease: 'none', scrollTrigger: { trigger: '.zyx .hero', start: 'top top', end: 'bottom top', scrub: true } });
    gsap.to('.zyx .hero__content', { yPercent: -18, opacity: 0, ease: 'none', scrollTrigger: { trigger: '.zyx .hero', start: 'top top', end: 'bottom 30%', scrub: true } });
  } else {
    $('.zyx .hero__fade').style.display = 'none';
    heroTitle.style.opacity = 1;
    $$('.zyx [data-hero-fade]').forEach(el => { el.style.opacity = 1; });
  }

  /* ---------- Neun Düfte: waagerechte Fahrt beim Scrollen (nur Desktop), Philosophie Wort für Wort ---------- */
  if (hasGSAP) {
    const mm = gsap.matchMedia();
    if (has('.zyx .rail__pin')) mm.add('(min-width: 1024px) and (prefers-reduced-motion: no-preference)', () => {
      const pin = $('.zyx .rail__pin');
      const rail = $('[data-rail]');
      const bar = $('[data-rail-progress]');
      const dist = () => Math.max(0, rail.scrollWidth - window.innerWidth);
      gsap.to(rail, {
        x: () => -dist(), ease: 'none',
        scrollTrigger: { trigger: pin, start: 'top top', end: () => '+=' + dist(), pin: true, scrub: 1, invalidateOnRefresh: true, onUpdate: self => { bar.style.transform = `scaleX(${self.progress})`; } }
      });
    });
    const words = site.split($('[data-words]'), 'mw');
    if (has('.zyx .manifest')) mm.add('(prefers-reduced-motion: no-preference)', () => {
      gsap.to(words, { opacity: 1, ease: 'none', stagger: .08, scrollTrigger: { trigger: '.zyx .manifest', start: 'top 65%', end: 'center 38%', scrub: true } });
      gsap.fromTo('.zyx .manifest__bg img', { yPercent: -9 }, { yPercent: 0, ease: 'none', scrollTrigger: { trigger: '.zyx .manifest', start: 'top bottom', end: 'bottom top', scrub: true } });
    });
    // Craft lädt Bilder und Apps nach: Positionen der Scroll-Effekte nachziehen
    window.addEventListener('load', () => window.ScrollTrigger.refresh());
  }

  site.reveals();

  /* ---------- In den Warenkorb ---------- */
  document.addEventListener('click', async e => {
    if (!e.target.closest('.zyx')) return;
    const q = e.target.closest('[data-quick]');
    if (q) {
      const s = D.scent(q.dataset.quick);
      cart.add([{ id: s.variant, quantity: 1 }], q.closest('.zy-card').querySelector('.zy-card__media'), D.img('pack-' + s.id, 240));
      return;
    }
    const setBtn = e.target.closest('[data-add-set]');
    if (setBtn) {
      const set = D.sets.find(x => x.id === setBtn.dataset.addSet);
      cart.add(set.scents.map(id => ({ id: D.scent(id).variant, quantity: 1 })), setBtn.closest('.set').querySelector('.set__media'), D.img('pack-' + set.scents[0], 240));
      return;
    }
    const trio = e.target.closest('[data-add-trio]');
    if (trio) {
      cart.add(D.perfume.trio.scents.map(id => ({ id: D.pf(id).variant, quantity: 1 })), $('.zyx .pfch__visual'), D.img('pf-trio', 1400));
      return;
    }
    const refill = e.target.closest('[data-add-refill]');
    if (refill) {
      // Refill passend zu einem Raumduft im Warenkorb, sonst die erste lieferbare Sorte
      let items = [];
      try { items = (await (await fetch((D.routes.root || '/').replace(/\/$/, '') + '/cart.js')).json()).items || []; } catch (err) { /* egal */ }
      const match = items.map(i => D.scents.find(s => s.variant === i.variant_id)).filter(Boolean).find(s => D.products.refill.variants.includes(s.name));
      cart.add([{ id: D.variantOf('refill', match ? match.name : null), quantity: 1 }], refill.closest('.refill-card').querySelector('.zy-media'), D.img('pack-refill', 300));
    }
  });
})();
